import { render, staticRenderFns } from "./viewConfig.vue?vue&type=template&id=721d3b54&scoped=true&"
import script from "./viewConfig.vue?vue&type=script&lang=js&"
export * from "./viewConfig.vue?vue&type=script&lang=js&"
import style0 from "./viewConfig.vue?vue&type=style&index=0&id=721d3b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d3b54",
  null
  
)

export default component.exports